import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IUpSell } from '../../../../../../api/api-checkout/models/rq-checkout-up-sell';
import { PricingDetail } from '../../../../../../api/api-checkout/models/rq-checkout-search';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../../../atoms';

@Component({
  selector: 'app-upsell-card',
  templateUrl: './upsell-card.component.html',
  styleUrls: ['./upsell-card.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonComponent],
})
export class UpsellCardComponent {
  @Input() item!: IUpSell;
  @Input() isDomestic!: boolean;
  @Input() pricingDetail!: PricingDetail;
  @Input() normalizing = true;
  @Output() select = new EventEmitter<IUpSell>();

  getPassengersDescription(): string {
    return this.pricingDetail.passengersCount > 1
      ? `Por los ${this.pricingDetail.passengersCount} pasajeros`
      : 'Por un pasajero';
  }
}
